import { PriceGroup } from '@adapters/bigcommerce/types/product';

export const albyTrackLoadPDP = (productCode: string) => {
  if (typeof window !== 'undefined') {
    window.albyTrack = window.albyTrack || [];
    window.albyTrack.push({
      event: 'LOAD_PDP',
      payload: {
        productId: productCode,
      },
    });
  }
};

export const albyTrackAddToCart = (
  sku?: string | null,
  price?: PriceGroup['price'] | null,
  quantity?: number | null
) => {
  if (typeof window !== 'undefined') {
    window.albyTrack = window.albyTrack || [];
    window.albyTrack.push({
      event: 'ADD_TO_CART',
      payload: {
        price: price,
        variantId: sku,
        quantity: quantity,
        currency: 'CAD',
      },
    });
  }
};
